import { Policy } from '../pages';

export default [
  {
    path: '/reem-central-policy',
    Component: Policy,
  },
];
